import { render } from "./Loadings.vue?vue&type=template&id=07839ec2&scoped=true"
import script from "./Loadings.vue?vue&type=script&lang=js"
export * from "./Loadings.vue?vue&type=script&lang=js"

import "./Loadings.vue?vue&type=style&index=0&id=07839ec2&scoped=true&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07839ec2"]])

export default __exports__